import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { Typography } from 'kangarootime-ui';

const Header = () => (
  <TableHead style={{ backgroundColor: '#F1F1F3' }}>
    <TableRow>
      <TableCell />
      <TableCell>
        <Typography>Photo</Typography>
      </TableCell>
      <TableCell>
        <Typography>Child</Typography>
      </TableCell>
      <TableCell>
        <Typography>Note</Typography>
      </TableCell>
      <TableCell>
        <Typography>Creator</Typography>
      </TableCell>
      <TableCell>
        <Typography>Date/Time</Typography>
      </TableCell>
      <TableCell align='right'>
        <Typography>Approve</Typography>
      </TableCell>
    </TableRow>
  </TableHead>
);

export default Header;
